import { Box, Button, Container, Stack, Text, Title } from "@mantine/core";
import { AppResources, AppRoutes } from "@/constants";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useState } from "react";
import { gradientTextStyle } from "@utils/brandStyles.ts";

const MobileView = () => {
  const [copied, setCopied] = useState(false);
  const gettingStartedUrl = `${window.location.origin}${AppRoutes.gettingStarted}?signIn=true`;

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(gettingStartedUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Container
      size="sm"
      p="xl"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack align="center" gap="xl" style={{ textAlign: "center" }}>
        {/* Wizzy Icon */}
        <Box
          style={{
            width: 200,
            height: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={AppResources.wizzyLiteHome}
            alt="Wizzy"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Title */}
        <Title order={2} style={{ fontSize: 24, fontWeight: 600 }}>
          <span style={{ ...gradientTextStyle(), fontWeight: 700 }}>Wizzy</span>{" "}
          works on a Desktop.
        </Title>

        {/* Instructions */}
        <Stack gap="md" style={{ maxWidth: 400 }}>
          <Text size="md" c="dimmed">
            To work with Wizzy, please open Chrome on your computer and visit:
          </Text>

          {/* URL Display and Copy Button */}
          <Box
            style={{
              backgroundColor: "var(--mantine-color-gray-1)",
              padding: "12px 16px",
              borderRadius: 8,
              border: "1px solid var(--mantine-color-gray-3)",
            }}
          >
            <Text
              size="sm"
              fw={500}
              style={{
                wordBreak: "break-all",
                fontFamily: "monospace",
              }}
            >
              {gettingStartedUrl}
            </Text>
          </Box>

          <Button
            leftSection={
              copied ? <IconCheck size={18} /> : <IconCopy size={18} />
            }
            variant={copied ? "light" : "filled"}
            color={copied ? "green" : "blue"}
            fullWidth
            onClick={handleCopyUrl}
          >
            {copied ? "Copied!" : "Copy Link"}
          </Button>

          <Text size="sm" c="dimmed" style={{ marginTop: 8 }}>
            SmartWiz Lite requires the Chrome browser and our extension to work
            properly.
          </Text>
        </Stack>
      </Stack>
    </Container>
  );
};

export default MobileView;
